module.exports = __webpack_public_path__ + "static/media/Named Buildings.cff7ceeb.jpeg";